import { render } from "./VtoHeaderArrow.vue?vue&type=template&id=ed03a6a0"
import script from "./VtoHeaderArrow.vue?vue&type=script&lang=js"
export * from "./VtoHeaderArrow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__